import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import * as companyApi from "../../api/companyApi/companyApi";

import CompanyForm from "./CompanyForm";
import {EQCompany, initializeCompany} from "../../models/serverModels/EQCompany";

const UpdateCompany = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: Officer, isLoading: isGetLoading} = useGetQuery<ResponseItem<EQCompany>>({
    key: ["Company", {token: tokenState, id: parseInt(id!)}],
    api: () => companyApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQCompany>,
    Params.Update<EQCompany>
  >({
    api: companyApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Company`);
        queryClient.invalidateQueries("CompanyList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<EQCompany>({defaultValues: initializeCompany()});

  const {reset} = methods;

  useEffect(() => {
    reset(Officer?.item);
  }, [Officer?.item, reset]);

  const onSubmit: SubmitHandler<EQCompany> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...Officer?.item, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="설비관리 업체 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <CompanyForm />
            <ConfirmButtonGroup link={`/Company`} cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateCompany;
